// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ivlP1","title":"styles_title__AjJXB"};